<h1 style="text-align: center; padding: 15px;">
  Calculator tabla acoperis - Afla costul in doar 5 pasi!
</h1>
<div class="drag-scroll-container">
  <drag-scroll class="container" style="height: 220px;">
    <div class="drag-scroll-item">
      <rc-rounded-step [step]="'👉'"></rc-rounded-step>
      <p>Alege tipul de acoperiș din lista de mai jos</p>
    </div>
    <div class="drag-scroll-item">
      <rc-rounded-step [step]="'👉'"></rc-rounded-step>
      <p>Alege modelul de tablă dorit</p>
    </div>
    <div class="drag-scroll-item">
      <rc-rounded-step [step]="'✍️'"></rc-rounded-step>
      <p>Introdu dimensiunile acoperișului și a sistemului pluvial sau anexelor (după caz)</p>
    </div>
    <div class="drag-scroll-item">
      <rc-rounded-step [step]="'✍️'"></rc-rounded-step>
      <p>Calculatorul îți va sugera accesoriile standard, ele se pot modifica.</p>
    </div>
    <div class="drag-scroll-item">
      <rc-rounded-step [step]="'💵'"></rc-rounded-step>
      <p>Vei vedea o ofertă detaliată cu cantități și preț</p>
    </div>
  </drag-scroll>
</div>

<calculation-types></calculation-types>

<h2 class="strike">
  <span class="strike-text">Calcul tabla acoperis - Beneficiaza de oferta</span>
</h2>
<div class="container" id="offers">
  <mat-card appearance="outlined" class="card-radius card-container">
    <img alt="Reducere la accesorii" mat-card-image class="image" src="assets/sale-icon.webp" />
    <mat-card-content class="content">
      <p><span style="font-size: 26px; font-weight: 500; color: #ff3131;">30%</span> reducere la accessorii</p>
      <p><em>Se aplică la comenzi de peste 4.000 RON</em></p>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" class="card-radius card-container">
    <img alt="Reducere la tabla" mat-card-image class="image" src="assets/sale-icon.webp" />
    <mat-card-content class="content">
      <p><span style="font-size: 26px; font-weight: 500; color: #ff3131;"> 5%</span> reducere la tablă</p>
      <p><em>La comenzi de peste 5.000 RON</em></p>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" class="card-radius card-container">
    <img alt="transport" mat-card-image class="image" src="assets/icon-transport.svg" />
    <mat-card-content class="content">
      <p>Transport gratuit oriunde in țară</p>
      <p><em>La comenzi de peste 3.000 RON. <br />Livrare in 2-7 zile lucrătoare</em></p>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" class="card-radius card-container">
    <img alt="garantie" mat-card-image class="image" src="assets/icon-30ani.svg" />
    <mat-card-content class="content">
      <p>Garanție până la 30 ani</p>
      <p><em><a href="https://expert-roof-systems.s3.eu-central-1.amazonaws.com/Certificat_garantie_RO.pdf">Certificat de
        garanție Bilka</a></em></p>
      <p><em><a href="https://expert-roof-systems.s3.eu-central-1.amazonaws.com/wetterbest-certificat-de-garantie.pdf">Certificat de
        garanție Wetterbest</a></em></p>
    </mat-card-content>
  </mat-card>
</div>
<h3 class="strike">
  <span class="strike-text">Calculator acoperiș Bilka & Wetterbest - Produse populare</span>
</h3>
<div style="width: 100%; overflow: scroll">
  <drag-scroll class="container" style="height: 460px;">
    <mat-card appearance="outlined" *ngFor="let product of products; let i = index" class="card-radius card-container">
      <mat-card-content class="content prevent-select">
        <a (click)="openDialog(i)">
          <img loading="lazy" [alt]="product.roofProduct.name + ' '+ product.roofFinish.finish + ' ' + product.roofColor.color"
               mat-card-image class="image"
               src="{{getImagePath(product.roofProduct.type, product.roofProduct.producer, product.roofProduct.name, product.roofFinish.finish, product.roofColor.color)}}" />
        </a>

        <p class="type text-bold">{{product.roofProduct.producer}} {{ product.roofProduct.name }}</p>
        <div class="content-">
          <p class="details">
            Finisaj: {{ product.roofFinish.finish | titleCase }}
          </p>
          <p class="details">
            Grosime: {{ product.roofThickness.thickness }}
          </p>
          <p class="details">
            Cod culoare: {{ product.roofColor.color }}
          </p>
        </div>
      </mat-card-content>
      <mat-card-footer class="footer text-bold">
        <ng-container *ngIf="product.price.discount">
          <span class="price old-price">Preț vechi: {{ product.price.price | roncurrency }}/mp.</span>
          <span class="price new-price">Preț nou: {{ product.price.price | discount: product.price.discount | roncurrency }}/mp.</span>
        </ng-container>
        <ng-container *ngIf="!product.price.discount">
          <span class="price">Preț: {{ product.price.price | roncurrency }}/mp.</span>
        </ng-container>
        <button mat-raised-button color="primary" (click)="openDialog(i)" gaEvent="home_add_to_cart" gaCategory="buttons_tracking">
          <mat-icon>shopping_cart</mat-icon>
          Cumpără
        </button>
      </mat-card-footer>
    </mat-card>
  </drag-scroll>
</div>
